import DtoJobLogLight from 'import/dto/DtoJobLogLight'
import { groupBy, keys, maxBy, orderBy, some, take, uniqBy } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import WaitAction from 'wait/WaitAction'
import Input from '../../../components/forms/Input'
import RadioButtons from '../../../components/forms/RadioButtons'
import { nbPerPageLabel } from '../../../referencial/constants/ReferencialConstants'
import { shortenHumanize } from '../../../utils/DateUtil'
import { exportFile, getDataWithHeaders } from '../../../utils/ExportDataUtil'
import { getExecStatusIcon } from '../../../utils/JobUtils'
import { hasValue } from '../../../utils/NumberUtil'
import JobAction from '../../actions/JobAction'
import Job from '../../dto/Job'
import JobLogTable from '../../dto/JobLogTable'
import Checkbox from '../../../components/forms/Checkbox'
import RefJobAction from '../../../domain/job/RefJobAction'
import DtoJobExecution from '../../dto/DtoJobExecution'
import MessageCard from '../../../components/card/MessageCard'
import ProgressCard from '../../../components/card/ProgressCard'
import ProgressBar from '../../../components/progress/ProgressBar'
import { CardContent, Grid, Card, Icon, Typography, Tooltip } from '@mui/material'
import { CardTable } from 'components/datatable/NewTable'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue, JOB_COLOR, lightBlue, PASTEL_COLOR } from 'utils/constants/ColorTheme'
import CmsLogTable from '../../../messages/components/cms/CmsLogTable'

const defaultLimit = 50000
const headersLogsExport = ['station', 'date', 'value', 'status', 'fileLabel']
const NO_DATA_PROCESS = 4

const GREEN = 'green'
const YELLOW = 'yellow'
const RED = 'red'

class ImportLogs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: undefined,
            selectedExecution: undefined,
            searchValue: '',
            filterColor: null,
            selectedStation: null,
            searchMode: 'station',
            searchLogs: '',
            limitLogs: defaultLimit,
            showInfo: true,
            showWarn: true,
            showErr: true,
            showSucc: true,
            jobLogsCount: undefined,
            jobLogs: [],
            jobLogsStations: [],
            limitExecutions: 100,
            jobExecutions: [],
            dataLoaded: false,
            nbStationsMax: 100,
            showDataExecutions: true,
        }
    }

    getSelectedExecutionLogs = (data) => {
        if (data.selectedExecutionId) {
            const datas = orderBy(data.logs.filter(s => s.status !== 'progress').map(l => new JobLogTable(l)), 'timestamp', 'desc')
            const cantLoadMore = data.nbLogs === this.state.jobLogsCount

            return (
                <CardTable
                    title={`${data.logs.length} / ${this.state.jobLogsCount || 0} ${this.state.jobLogsCount > 0 ? i18n.elements : i18n.element}`}
                    actions={[
                        {
                            icon: 'file_download',
                            tooltip: i18n.export,
                            color: 'white',
                            onClick: () => {
                                const datasToExport = datas.map(d => ({
                                    ...d,
                                    station: { value: d.station, cellType: 'string' },
                                    date: { value: d.date, cellType: 'string' },
                                }))
                                exportFile(this.onExport(getDataWithHeaders(datasToExport, headersLogsExport), i18n.exportName))
                            },
                            'data-cy': 'export_logo',
                        },
                        {
                            icon: 'more_horiz',
                            color: `${cantLoadMore ? '#9e9e9e' : 'white'}`,
                            tooltip: i18n.displayMore,
                            onClick: cantLoadMore ? () => {} : () => this.setState({ limitLogs: this.state.limitLogs*2 }, this.fetchJobLogs),
                            'data-cy': 'logo_three_dot',
                        },
                    ]}
                    rows={datas}
                    rowsPerPageOptions={nbPerPageLabel}
                    headers={[ { key: 'station', value: i18n.elementLabel }, 'date', { key: 'value', value: i18n.valueLabel }, 'status', 'fileLabel']}
                    sx={{
                        paddingLeft: '10px',
                        maxHeight: '62vh',
                        overflow: 'auto',
                    }}
                    color={darkBlue}
                    inverseDisplay
                    noDataDisplay={!cantLoadMore && !datas.length && (
                        <Card>
                            <CardContent>
                                <Grid container size={12} justifyContent='center' alignItems='center' spacing={1} sx={{ padding: '5 10 5 0' }}>
                                    <Typography variant='h6' fontWeight='bold'>{i18n.displayMore}</Typography>
                                    <Icon
                                        tooltip={i18n.displayMore}
                                        onClick={cantLoadMore ? () => {} : () => this.setState({ limitLogs: this.state.limitLogs*2 }, this.fetchJobLogs)}
                                    >more_horiz</Icon>
                                </Grid>
                            </CardContent>
                        </Card>
                    )}
                    disableLocalStorage
                />
            )
        }
        return <h6>{i18n.jobHasNoExecutions}</h6>
    }

    handleClickColor = (color) => this.setState({ filterColor: !this.state.filterColor || this.state.filterColor !== color ? color : null, selectedStation: null })

    getBgColor = (color) => !this.state.filterColor || this.state.filterColor === color ? PASTEL_COLOR[color] : 'grey'

    getStationList = (data) => {
        const stationList = data.stations
        const count = stationList.map(s => s.code).includes(i18n.unknown) ? stationList.length-1 : stationList.length
        const displayedStations = take(data.stationsFiltered, this.state.nbStationsMax)
        return (
            <Card>
                <CardContent sx={{ padding: 0 }}>
                    <Grid container rowSpacing={1} justifyContent='space-around'>
                        <Grid size={12} sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                            { `${count} ${this.state.searchMode === 'station' ? i18n.elementsLabel : i18n.files}` }
                        </Grid>
                        <Grid size={4}>
                            <span className={ 'arrests-level-panel white-text bold clickable' } style={{ backgroundColor: `${this.getBgColor(GREEN)}`, 'font-weight': 'bold' }} onClick={ () => this.handleClickColor(GREEN) }>
                                { stationList.filter(s => s.color === GREEN).length }
                            </span>
                        </Grid>
                        <Grid size={4}>
                            <span className={ 'arrests-level-panel white-text bold clickable' } style={{ backgroundColor: `${this.getBgColor(RED)}`, 'font-weight': 'bold' }} onClick={ () => this.handleClickColor(RED) }>
                                { stationList.filter(s => s.color === RED).length }
                            </span>
                        </Grid>
                        <Grid size={4}>
                            <span className={ 'arrests-level-panel white-text bold clickable' } style={{ backgroundColor: `${this.getBgColor(YELLOW)}`, 'font-weight': 'bold' }} onClick={ () => this.handleClickColor(YELLOW) }>
                                { stationList.filter(s => s.color === YELLOW).length }
                            </span>
                        </Grid>
                        <Grid size={12} sx={{ maxHeight: '549px', overflow: 'scroll' }}>
                            { displayedStations.map((s, i) => (
                                <Grid
                                    className={ `clickable ${this.state.selectedStation === s.code ? 'selectedStationJobLog' : 'stationJobLog'}` }
                                    key={i}
                                    sx={{ backgroundColor: s.bgColor }}
                                    onClick={ () => this.setState({ selectedStation: s.code === this.state.selectedStation ? null : s.code }) }
                                >
                                    { s.code }
                                </Grid>))
                            }
                            {
                                displayedStations.length < data.stationsFiltered.length ? (
                                    <Grid onClick={() => this.setState({ nbStationsMax: this.state.nbStationsMax+100 })} className='clickable'>
                                        {i18n.displayMore}
                                    </Grid>
                                ) : null
                            }
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }

    componentDidMount() {
        const { jobExecutionId } = queryString.parse(this.props.location.search)
        if (hasValue(jobExecutionId)) {
            this.onClickExecution(parseInt(jobExecutionId))
        } else {
            this.fetchJobLogs()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.nbExecutions !== this.props.nbExecutions) {
            this.fetchJobLogs(true)
        }
    }

    fetchJobLogs = (takeLast) => {
        const { limitLogs, limitExecutions, selected } = this.state
        const jobId = this.props.job.id
        RefJobAction.promiseJobExecutions(jobId, limitExecutions).then(execs => {
            const jobExecutions = execs.map(el => new DtoJobExecution(el))
            const jobExecutionId = takeLast ? maxBy(jobExecutions, 'date')?.id : (selected ?? maxBy(jobExecutions, 'date')?.id)
            JobAction.requestJobLogs(jobId, jobExecutionId, limitLogs).then(json => {
                this.setState({
                    selected: jobExecutionId,
                    selectedExecution: json.execution,
                    jobLogsCount: json.count,
                    jobLogs: json.data.map(el => new DtoJobLogLight({ ...el, jobExecutionId, jobId })),
                    jobLogsStations: json.stations,
                    jobExecutions,
                    dataLoaded: true,
                })
                if (!this.autoReload) {
                    this.autoReload = true
                    this.launchTimeout()
                }
            })
        })
    }

    launchTimeout = () => {
        this.reloadTimeout = setTimeout(this.manageAutoReload, 5000)
    }

    componentWillUnmount() {
        clearTimeout(this.reloadTimeout)
    }

    manageAutoReload = () => {
        this.autoReload = false
        const { selectedExecution, jobExecutions } = this.state
        const lastExec = maxBy(jobExecutions, 'date')
        if (!hasValue(lastExec.status) || !hasValue(selectedExecution.status)) {
            this.fetchJobLogs()
        }
    }

    onClickExecution = id => this.setState({ selected: id, limitLogs: defaultLimit }, this.fetchJobLogs)

    getTables = () => {
        return this.state.jobExecutions.map(e => {
            const date = moment(e.date)
            const duration = hasValue(e.duration) ? shortenHumanize(e.duration * 1000) : e.status !== 7 ? shortenHumanize(moment().valueOf() - e.date) : 0
            return {
                id: e.id,
                status: getExecStatusIcon(e, 50),
                statusValue: (e.status ?? e.statusCode),
                date: `${date.format('DD/MM/YYYY')} ${date.format('HH:mm')}`,
                duration,
                colorLine: this.state.selected === e.id ? lightBlue : 'white',
                stopExecution: !hasValue(e.status) && !hasValue(e.duration) ?
                    <Tooltip title={i18n.stopExecution}>
                        <Grid sx={{ width: `${25}px` }}>
                            <Icon
                                sx={{ color: 'blue', fontSize: `${25}px` }}
                                onClick={() => this.props.abortExecution(this.props.job.id, e).then(() => this.fetchJobLogs())}
                            >
                                pan_tool
                            </Icon>
                        </Grid>
                    </Tooltip> : null,
            }
        })
    }

    getLogsAndStations = () => {
        const { selectedExecution, jobLogs, searchValue, searchMode, searchLogs, jobLogsStations, filterColor, selectedStation } = this.state
        if (selectedExecution) {
            const executionLogs = jobLogs.filter(l => l.jobId === this.props.job.id && !l.status.startsWith('file') && (!searchLogs || (l.value || '').toLowerCase().includes(searchLogs.toLowerCase())))
            const lowered = searchValue.toLowerCase()
            const filtered = hasValue(searchValue) ? executionLogs.filter(l => (l[searchMode] || '').toLowerCase().includes(lowered)) : executionLogs

            const logLevelsToRemove = ['showInfo', 'showWarn', 'showErr', 'showSucc'].filter(key => this.state[key] === false)
            const filtered2 = logLevelsToRemove.length ? logLevelsToRemove.reduce((acc, key) => {
                if (key === 'showInfo') {
                    return acc.filter(l => ['warning', 'error', 'success'].includes(l.status))
                }
                if (key === 'showWarn') {
                    return acc.filter(l => l.status !== 'warning')
                }
                if (key === 'showErr') {
                    return acc.filter(l => l.status !== 'error')
                }
                return acc.filter(l => l.status !== 'success')
            }, filtered) : filtered

            const groups = groupBy(filtered2, e => e[searchMode]?.trim() || i18n.unknown)
            const stationList = hasValue(searchValue) || hasValue(searchLogs) || logLevelsToRemove.length || searchMode === 'fileName' ? keys(groups).map(stationKey => {
                const logs = uniqBy(groups[stationKey], 'status')
                const color = (() => {
                    if (some(logs, l => l.status === 'error')) {
                        return { color: RED, bgColor: JOB_COLOR.RED }
                    }
                    if (some(logs, l => l.status === 'warning')) {
                        return { color: YELLOW, bgColor: JOB_COLOR.YELLOW }
                    }
                    if (some(logs, l => l.status === 'success')) {
                        return { color: GREEN, bgColor: JOB_COLOR.GREEN }
                    }
                    return {}
                })()
                return { code: stationKey, ...color, logs: groups[stationKey] }
            }) : jobLogsStations.map(stationLogs => {
                const key = hasValue(stationLogs[0].trim()) ? stationLogs[0] : i18n.unknown
                const color = (() => {
                    if (stationLogs[1] === 3) {
                        return { color: RED, bgColor: JOB_COLOR.RED }
                    }
                    if (stationLogs[1] === 2) {
                        return { color: YELLOW, bgColor: JOB_COLOR.YELLOW }
                    }
                    if (stationLogs[1] === 1) {
                        return { color: GREEN, bgColor: JOB_COLOR.GREEN }
                    }
                    return {}
                })()
                return { code: key, ...color, logs: groups[key] || [] }
            })
            const stationsOrdred = orderBy(stationList, s => s.logs.length ? s.logs[0].date : 0, 'desc')
            const filterByColor = filterColor ? stationsOrdred.filter(s => s.color === filterColor) : stationsOrdred
            const filterByStation = selectedStation ? filterByColor.filter(s => s.code === selectedStation) : filterByColor
            return { stations: stationsOrdred, stationsFiltered: filterByColor, logs: filterByStation.flatMap(s => s.logs), selectedExecutionId: selectedExecution.id, nbLogs: executionLogs.length }
        }
        return { stations: [], logs: [] }
    }

    onExport = (datas, title) => ({
        data: datas,
        exportType: 'xlsx',
        titleFile: title || `${i18n.job}_n${this.props.job.id}_${i18n.executions}`,
    })

    getLogHeader = (selectedExecution) => {
        return (
            `${i18n.execution} ${selectedExecution.id} - ${moment(selectedExecution.date).format('DD/MM/YYYY-HH:mm')} (${shortenHumanize(selectedExecution.duration * 1000)})`
        )
    }
    render() {
        const { selectedExecution, dataLoaded, jobExecutions, searchMode, searchValue, searchLogs, showInfo, showSucc, showWarn, showErr, showDataExecutions } = this.state
        const data = this.getLogsAndStations()
        if (!dataLoaded) {
            return <ProgressCard indeterminate withMessage/>
        }
        if (!jobExecutions?.length) {
            return <MessageCard>{i18n.jobHasNoExecutions}</MessageCard>
        }
        const progress = selectedExecution?.status === undefined ? orderBy(data.logs.filter(l => l.status === 'progress'), 'date', 'desc')?.[0]?.value : undefined
        const dataTable = showDataExecutions ? this.getTables() : this.getTables().filter(d => d.statusValue !== NO_DATA_PROCESS)
        return (
            <Card>
                <CardContent>
                    <Grid container spacing={1}>
                        <Grid size={3}>
                            <CardTable
                                rows={dataTable}
                                headers={ ['status', 'date', 'duration', 'stopExecution'] }
                                title={i18n.executions}
                                hideNbElements
                                displayHeaders={false}
                                color={darkBlue}
                                onClickRow={(v) => this.onClickExecution(v.id)}
                                actions={[
                                    {
                                        icon: 'local_cafe',
                                        tooltip: i18n.displayEmptyExecutions,
                                        color: showDataExecutions ? 'green' : 'red',
                                        onClick: () => this.setState({ showDataExecutions: !showDataExecutions }),
                                    },
                                    {
                                        icon: 'file_download',
                                        tooltip: i18n.export,
                                        color: 'white',
                                        onClick: () => {
                                            const exportDataFormated = this.getTables()
                                            const exportData = exportDataFormated.length ? [{ ...exportDataFormated[0], headers: ['id', 'statusValue', 'date', 'duration'] }, ...exportDataFormated.slice(1)] : []
                                            exportFile({
                                                data: exportData,
                                                exportType: 'xlsx',
                                                titleFile: 'executions',
                                            })
                                        },
                                    },
                                    {
                                        icon: 'more_horiz',
                                        tooltip: i18n.displayMore,
                                        color: 'white',
                                        onClick: () => this.setState({ limitExecutions: this.state.limitExecutions + 100 }, this.fetchJobLogs)
                                    }]
                                }
                            />
                            { progress && <ProgressBar progress={parseInt(progress)} withMessage/> }
                        </Grid>
                        <Grid size={9}>
                            { selectedExecution && (
                                <>
                                    <CardTitle title={this.getLogHeader(selectedExecution)} color={darkBlue} />
                                    <Grid container sx={{ paddingTop: '5px' }}>
                                        <Grid size={2}>
                                            {this.getStationList(data)}
                                        </Grid>
                                        <Grid container size={10} justifyContent='space-around' alignItems='center' alignContent='flex-start'>
                                            <Grid size={2}>
                                                <Input
                                                    title={ searchMode === 'station' ? i18n.elementLabel : i18n.fileLabel }
                                                    value={ searchValue }
                                                    onChange={ v => this.setState({ searchValue: v, selectedStation: null, filterColor: null }) }
                                                />
                                            </Grid>
                                            <Grid size={3}>
                                                <RadioButtons
                                                    elements={ [{ code: 'station', name: i18n.elementsLabel }, { code: 'fileName', name: i18n.fileLabel }] }
                                                    selected={ searchMode }
                                                    onChange={ v => this.setState({ searchMode: v, searchValue: '', selectedStation: null, filterColor: null })}
                                                    title={ i18n.researchType }
                                                />
                                            </Grid>
                                            <Grid size={2}>
                                                <Input
                                                    title={ i18n.searchInLogs }
                                                    value={ searchLogs }
                                                    onChange={ v => this.setState({ searchLogs: v, selectedStation: null, filterColor: null }) }
                                                />
                                            </Grid>
                                            <Grid size={1}>
                                                <Checkbox
                                                    label='INFO'
                                                    checked={ showInfo }
                                                    onChange={ v => this.setState({ showInfo: v })}
                                                />
                                            </Grid>
                                            <Grid size={1}>
                                                <Checkbox
                                                    label={<span className='arrests-level-panel' style={{ backgroundColor: PASTEL_COLOR.green }}>&nbsp;&nbsp;&nbsp;</span>}
                                                    checked={ showSucc }
                                                    onChange={ v => this.setState({ showSucc: v })}
                                                />
                                            </Grid>
                                            <Grid size={1}>
                                                <Checkbox
                                                    label={<span className='darken-1 arrests-level-panel' style={{ backgroundColor: PASTEL_COLOR.yellow }}>&nbsp;&nbsp;&nbsp;</span>}
                                                    checked={ showWarn }
                                                    onChange={ v => this.setState({ showWarn: v })}
                                                />
                                            </Grid>
                                            <Grid size={1}>
                                                <Checkbox
                                                    label={<span className='arrests-level-panel' style={{ backgroundColor: PASTEL_COLOR.red }}>&nbsp;&nbsp;&nbsp;</span>}
                                                    checked={ showErr }
                                                    onChange={ v => this.setState({ showErr: v })}
                                                />
                                            </Grid>
                                            <Grid size={12} data-cy='logsTable'>
                                                { this.getSelectedExecutionLogs(data) }
                                                <CmsLogTable
                                                    jobExecutionId={selectedExecution.id}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            ) }
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }
}

ImportLogs.propTypes = {
    nbExecutions: PropTypes.number,
    params: PropTypes.shape({
        id: PropTypes.number,
    }),
    job: PropTypes.instanceOf(Job).isRequired,
    abortExecution: PropTypes.func,
    reloadExecutions: PropTypes.func,
    waitStart: PropTypes.func,
    waitStop: PropTypes.func,
    excludeEmpty: PropTypes.bool,
    onExcludeEmpty: PropTypes.func,
    location: PropTypes.object,
    setTimeout: PropTypes.func,
}

ImportLogs.defaultProps = {
    job: {},
}


const mapDispatchToProps = {
    abortExecution: JobAction.abortExecution,
    waitStart: WaitAction.waitStart,
    waitStop: WaitAction.waitStop,

}

export default connect(null, mapDispatchToProps)(ImportLogs)
